__turbopack_context__.v({
  "root": "bTf5Aa_root",
  "sticky": "bTf5Aa_sticky",
});
